import request from '@/utils/request'

//新增客户数据
export  function SaveCustomer(data){
    return request({
        url:'/oa_ows/oa/ows/chat/SaveCustomer',
        method:'Post',
        data:data
    })
}

//查询意向下拉选项
export  function GetProductLineList(query){
    return request({
        url:'/oa_ows/oa/ows/chat/GetProductLineList',
        method:'Get',
        params:query
    })
}

//查询会话数据
export  function GetSessionRecord(query){
    return request({
        url:'/oa_ows/oa/ows/chat/GetSessionRecord',
        method:'Get',
        params:query
    })
}
//修改对话
export  function UpdateChat(data){
    return request({
        url:'/oa_ows/oa/ows/chat/UpdateChat',
        method:'Post',
        data:data
    })
}